import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';
import * as Sentry from '@sentry/react';
import { initSentry } from '@clatter/platform';
import { store } from './app/store';

import App from './app/app';

initSentry({ appName: 'ng' });

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

if (!process.env.NX_PUBLIC_MUI_LICENSE_KEY) {
  console.warn('⚠️ NX_PUBLIC_MUI_LICENSE_KEY is not set!');
}

if (!process.env.NX_PUBLIC_AUTH0_NAMESPACE) {
  console.warn('⚠️ NX_PUBLIC_AUTH0_NAMESPACE is not set!');
}

if (!process.env.NX_PUBLIC_APP_VERSION) {
  console.warn('⚠️ NX_PUBLIC_APP_VERSION is not set!');
}

if (!process.env.NX_PUBLIC_SITES_HOST) {
  console.warn('⚠️ NX_PUBLIC_SITES_HOST is not set!');
}

if (process.env.NX_PUBLIC_MUI_LICENSE_KEY) {
  LicenseInfo.setLicenseKey(process.env.NX_PUBLIC_MUI_LICENSE_KEY);
  console.log('✅ MUI License key set successfully');
} else {
  console.warn('⚠️ MUI License key not set - NX_PUBLIC_MUI_LICENSE_KEY is missing');
}

async function bootstrap() {
  // const { worker } = await import('./mocks/browser');
  // await worker.start({ onUnhandledRequest: 'bypass' });

  const root = createRoot(document.getElementById('root') as HTMLElement);

  root.render(
    <StrictMode>
      <Provider store={store}>
        <Sentry.ErrorBoundary
          fallback={({ error }) => (
            <div style={{ fontFamily: 'Arial, sans-serif', textAlign: 'center', padding: '50px', backgroundColor: '#f9f9f9', color: '#333', minHeight: '100vh' }}>
              <div style={{ display: 'inline-block', background: '#fff', padding: '40px 60px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
                <img src="https://getclatter.com/wp-content/uploads/2023/01/clatter_logo.png" alt="Clatter Logo" style={{ maxWidth: '200px', marginBottom: '30px' }} />
                <h1 style={{ fontSize: '28px', marginBottom: '20px' }}>Something went wrong</h1>
                <p style={{ fontSize: '16px', lineHeight: '1.5' }}>An unexpected error occurred. Please refresh the page or contact support if the problem persists.</p>
                {process.env['NODE_ENV'] !== 'production' && <p style={{ fontSize: '14px', color: '#999', marginTop: '16px' }}>{error instanceof Error ? error.message : String(error)}</p>}
              </div>
            </div>
          )}
        >
          <App />
        </Sentry.ErrorBoundary>
      </Provider>
    </StrictMode>,
  );
}

bootstrap();
